declare const process: {
  env: {
    NODE_ENV: string;
  };
};

let config = {
  hosts: {
    api: 'https://hydrants.theamazing.cloud/api'
  }
};

if (process.env.NODE_ENV === 'development') {
  config.hosts.api = 'http://localhost:3000/api';
}

export default config;
